export const messages = {
  en: {
    communityPublicityManage: {
      searchTitle: 'Search Conditions',
      titlePlaceholder: 'Please enter publicity title',
      tableTitle: 'Community Publicity List',
      headerImg: 'Header Image',
      title: 'Publicity Title',
      pubType: 'Publicity Type',
      createTime: 'Publicity Time',
      publisher: 'Publisher',
      deleteTitle: 'Confirm Delete',
      deleteConfirm: 'Are you sure to delete this community publicity?',
      deleteSuccess: 'Delete successfully',
      deleteError: 'Delete failed'
    }
  },
  zh: {
    communityPublicityManage: {
      searchTitle: '查询条件',
      titlePlaceholder: '请输入公示标题',
      tableTitle: '小区公示列表',
      headerImg: '头部照片',
      title: '公示标题',
      pubType: '公示类型',
      createTime: '公示时间',
      publisher: '发布人',
      deleteTitle: '确认删除',
      deleteConfirm: '确定要删除这条小区公示吗？',
      deleteSuccess: '删除成功',
deleteError: '删除失败'
    }
  },
  'zh-TW': {
    communityPublicityManage: {
      searchTitle: '查詢條件',
      titlePlaceholder: '請輸入公示標題',
      tableTitle: '小區公示列表',
      headerImg: '頭部照片',
      title: '公示標題',
      pubType: '公示類型',
      createTime: '公示時間',
      publisher: '發布人',
      deleteTitle: '確認刪除',
      deleteConfirm: '確定要刪除這條小區公示嗎？',
      deleteSuccess: '刪除成功',
      deleteError: '刪除失敗'
    }
  }
}